import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, FormControl } from '@angular/forms';
import { PageBuilderLabelModel, PAGE_BUILDER_LABEL_TEXT_STYLE } from '../page-builder-label.model';

@Component({
    selector: 'abw-page-builder-label-design',
    templateUrl: './page-builder-label-design.component.html',
    styleUrls: ['./page-builder-label-design.component.scss']
})
export class PageBuilderLabelDesignComponent {
    @Input() model: PageBuilderLabelModel;
    @Input() value: string;
    PAGE_BUILDER_LABEL_TEXT_STYLE = PAGE_BUILDER_LABEL_TEXT_STYLE;
}